import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../store/user";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, token } = useSelector(
    (state) => state.user
  );
  useEffect(() => {
    if (token) {
      navigate("/locations");
    }
  }, [token, navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    const loginData = {
      username: username,
      password: password
    };
    dispatch(login(loginData));
  };

  return (
    <>
      <div className="flex h-screen text-center justify-center items-center">
        <form onSubmit={handleLogin} className="flex flex-col gap-6 w-[20%] p-8 bg-[linear-gradient(180deg,_rgba(1,74,74,0.70)_0%,rgba(20,20,20,1)_100%)] rounded-lg customShadow shadow-[#003333]">
          <p className="text-2xl mb-4">Login</p>
          <div className="flex flex-col gap-2">
            <p>Username</p>
            <input
              className="bg-transparent border-b-2"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-2">
            <p>Password</p>
            <input
              className="bg-transparent border-b-2"
              value={password}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && (
            <span style={{ color: "red" }}>
              Ops, qualcosa è andato storto! (Verifica email e password e
              riprova).
            </span>
          )}
          <div className="flex align-center justify-center mt-4">
            <button className="w-20 bg-[#007474] p-2 rounded-xl cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]">Accedi</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
